const isEntitlementAcsContainerHub = (entitlement) =>
  entitlement && (entitlement.application === 'ContainerHub' || entitlement.application === 'AzureContainerHub')

export default isEntitlementAcsContainerHub
